import styled from '@emotion/styled'
import { EAffiliatePartnerUserStatus } from '~/graphql/types'
import { colorUserStatus } from '~/utils'

type ContainerProps = {
  status: EAffiliatePartnerUserStatus;
}
export const Container = styled.div<ContainerProps>`
  span {
    ${(props) => colorUserStatus(props.status)}
    padding: .2rem .6rem;
    border-radius: .4rem;
    font-weight: 600;
    white-space: nowrap;
    font-size: .8rem;
  }
`
